import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/videoData";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20cinematic%20entertainment%20background%20with%20glowing%20neon%20lines%20and%20particles%2C%20modern%20high%20tech%20style%2C%20deep%20dark%20blue%20and%20warm%20amber%20accents%2C%20luxury%20cinema%20atmosphere%2C%20elegant%20flowing%20light%20ribbons%2C%20premium%20streaming%20service%20feel&width=1600&height=900&seq=hero-bg-video-01&orientation=landscape"
        alt="国产91视频 - 在线视频资源平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 py-16 md:py-24 max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
          发现万千精彩视频
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          {siteInfo.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/remen-tuijian"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-fire-line mr-2"></i>
            热门推荐
          </Link>
          <Link
            to="/category/zuixin-shangxian"
            className="px-8 py-3 rounded-full bg-white/10 backdrop-blur-sm text-white border border-white/20 font-medium text-sm hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            <i className="ri-rocket-line mr-2"></i>
            最新上线
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { label: "久久视频", icon: "ri-play-circle-line" },
            { label: "芒果视频", icon: "ri-tv-2-line" },
            { label: "97视频", icon: "ri-live-line" },
            { label: "丝瓜视频", icon: "ri-smartphone-line" },
            { label: "蓝莓视频", icon: "ri-computer-line" },
          ].map((item) => (
            <span key={item.label} className="flex items-center gap-1.5 text-white/60 text-xs">
              <i className={`${item.icon} text-sm`}></i>
              {item.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}